"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_96_101_0 = void 0;
/**
 * change ArtNr for Ringtrenssteg details see EKE-13294
 */
const migration_96_101_0 = (json) => {
    var _a;
    (_a = json.IAs) === null || _a === void 0 ? void 0 : _a.forEach((ia) => {
        if (ia.ArtNrGenerated === 'SK20.2.H.5.J' || ia.ArtNrGenerated === 'SK20-2-H-5-J') {
            ia.ArtNr = { DE: 'SK20.2.H.5.1', US: 'SK20-2-H-5-1' };
            ia.ArtNrGenerated = ia.ArtNrGenerated.replace('J', '1');
        }
        if (ia.ArtNrGenerated === 'SK28.3.H.5.1.J' || ia.ArtNrGenerated === 'SK28-3-H-5-1-J') {
            ia.ArtNr = { DE: 'SK28.3.H.5.1', US: 'SK28-3-H-5-1' };
            ia.ArtNrGenerated = ia.ArtNrGenerated.replace('1.J', '1');
            ia.ArtNrGenerated = ia.ArtNrGenerated.replace('1-J', '1');
        }
        if (ia.ArtNrGenerated === 'SK40.3.H.5.1.J' || ia.ArtNrGenerated === 'SK40-3-H-5-1-J') {
            ia.ArtNr = { DE: 'SK40.3.H.5.1', US: 'SK40-3-H-5-1' };
            ia.ArtNrGenerated = ia.ArtNrGenerated.replace('1.J', '1');
            ia.ArtNrGenerated = ia.ArtNrGenerated.replace('1-J', '1');
        }
    });
    return json;
};
exports.migration_96_101_0 = migration_96_101_0;
//# sourceMappingURL=migration_96_101_0.js.map